// water column (wc / inWC) values are always displayed to this many decimals
export const WATER_COLUMN_DECIMALS = 4

// true for any spelling of inches of water column the app uses as a unit
// label ('wc', ' wc', 'inWC')
export const isWaterColumn = units =>
  typeof units === 'string' && /^(in)?\s*wc$/i.test(units.trim())

// decimals to display a pressure in the given units, falling back to
// `defaultDecimals` for anything other than water column
export const getPressureDecimals = (units, defaultDecimals = 3) =>
  isWaterColumn(units) ? WATER_COLUMN_DECIMALS : defaultDecimals

// a pressure value as a string with its units' display precision. Values that
// aren't numbers, or units with a null `defaultDecimals`, are returned
// unchanged.
export const formatPressureValue = (value, units, defaultDecimals = 3) => {
  const num = parseFloat(value)
  const decimals = getPressureDecimals(units, defaultDecimals)
  if (value === null || value === undefined || isNaN(num) || decimals == null) {
    return value
  }

  return num.toFixed(decimals)
}

// pressure monitor measurement_units enum values (PRESSURE_MONITOR_MEASUREMENT_UNITS)
const MEASUREMENT_UNIT_RAW = 0
const MEASUREMENT_UNIT_PA = 2
// Pa thresholds match the precision the device displays
const PA_DECIMALS = 2

// a pressure monitor threshold with its units, e.g. '-0.0100 wc' or
// '-2.49 Pa'. Like atlas_backend, Default (or missing) units are treated as
// wc, and raw values are shown unconverted. Blank values return '--'.
export const formatPressureThreshold = (value, measurementUnits) => {
  const num = parseFloat(value)
  if (value === null || value === undefined || isNaN(num)) {
    return '--'
  }

  const units =
    measurementUnits === null || measurementUnits === undefined
      ? null
      : Number(measurementUnits)
  if (units === MEASUREMENT_UNIT_RAW) {
    return `${num} raw`
  }
  if (units === MEASUREMENT_UNIT_PA) {
    return `${num.toFixed(PA_DECIMALS)} Pa`
  }
  return `${num.toFixed(WATER_COLUMN_DECIMALS)} wc`
}
